"use client";

import { CandidateLogoBase, type CandidateLogoBaseProps } from "./candidate-logo-base";

export type CertificateLogoProps = Omit<
  CandidateLogoBaseProps,
  "fallbackIcon" | "fallbackLabel"
>;

export function CertificateLogo(props: CertificateLogoProps) {
  return (
    <CandidateLogoBase
      fallbackIcon="IconMedal"
      fallbackLabel="Certificate logo"
      {...props}
    />
  );
}
